// import components
import {ThemeProvider} from '@mui/material/styles';
import CssBaseLine from '@mui/material/CssBaseline';

// import utils
import {createTheme} from '@mui/material/styles';
import deepMerge from '@sdb/ui/common-utils/object/deepMerge.util';

// import theme
import {muiThemeOptions} from '@sdb/ui/mui-theme/mui.theme';

// import types
import type {MuiThemeOptions} from '@sdb/ui/types/theme/mui.types';

const theme = createTheme(
    deepMerge<NonNullable<MuiThemeOptions>>(muiThemeOptions, {
        colorSchemes: {
            dark: false,
        },
    }),
);

// import types
import type {PropsWithChildren} from 'react';

export const SDBThemeProvider = ({children}: PropsWithChildren) => (
    <ThemeProvider theme={theme}>
        <CssBaseLine />
        {children}
    </ThemeProvider>
);

export default SDBThemeProvider;
